import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    ViewChildren
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Country, CountryCod} from 'app/shared/models/artigos/country-code-json/country-cod';
import {ClienteContactos} from 'app/shared/models/clientes/cliente-contactos';
import {ComponenteTelefonico} from 'app/shared/models/recursos-humanos/Colaboradores/componente-telefonico';
import {AplicacaoService} from 'app/shared/services/aplicacao-service/aplicacao.service';
import {Subscription} from 'rxjs';
import {Paises} from '../../../models/aplicacao/paises';
import {Accao} from '../../../models/ENUM';
import {PhoneComponent} from '@shared/components/telefone/app-phone';

const CONTACTOS_INICIAIS: any[] = [
    {idTipoContacto: 1},
    {idTipoContacto: 1},
    {idTipoContacto: 2},
    {idTipoContacto: 2},
    {idTipoContacto: 3},
    {idTipoContacto: 3},
];

@Component({
    selector: 'app-contacto',
    templateUrl: './contacto.component.html',
    styleUrls: ['./contacto.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CountryCod]
})
export class ContactoComponent implements OnInit, AfterViewInit, OnChanges {
    public formContacto: FormGroup;
    protected mostrarDelete: number;
    protected listaTiposContactos;
    protected listaContriesFlag: any[];
    ContactosRemover = new Set<number>();
    protected initVectorComponenteTelefonico: ComponenteTelefonico[];
    // protected idsRentecoesClientes: number[];
    protected selectedRows: any[];
    protected isoCountryCode: Country;
    protected indicativoActual: string;
    protected telInvalido: boolean;
    protected selected: any[];
    protected selTel: Country;
    protected strSelect1: string;
    protected strSelect2: string;
    protected countryCode: string;
    protected valido = true;
    protected subscriptions: Subscription[];
    @Input('listaDeContactos') listaDeContactos: ClienteContactos[];
    @Input('obterListasContacto') obterListasContacto = false;
    @Input('idCliente') idCliente = 0;
    @Input('actualizarListasContacto') actualizarListasContacto = false;
    @Output('obterLista') obterLista: any = new EventEmitter();
    @Input() validarLista = true;
    @Input() paises: Paises[] = [];
    @Input() accao = '';
    @ViewChildren('matSelect1') contactosRef: any[] = [];
    @ViewChildren(PhoneComponent) phoneComponents!: QueryList<PhoneComponent>;
    readonly actions = Accao;
    loading = true;

    constructor(
        private fb: FormBuilder,
        private countryCod: CountryCod,
        private aplicacao: AplicacaoService
    ) {

        this.subscriptions = [];
        this.listaTiposContactos = [];
        this.listaDeContactos = [];
        this.listaContriesFlag = this.countryCod.getContryObject();
        this.selectedRows = [];
        this.isoCountryCode = null;
        this.indicativoActual = '';
        this.telInvalido = true;
        this.selected = [];
        this.selTel = null;
        this.accao = 'C';
        this.initStrSelect();
        this.formContacto = this.fb.group({
            contactos: this.fb.array([])
        });

    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.aplicacao.getTiposContactos()
                .subscribe(tiposContacto => {
                    this.loading = false;
                    this.listaTiposContactos = tiposContacto.filter(
                        x => x.tipoContacto?.trim()?.toUpperCase() !== 'FAX'
                        && x.tipoContacto?.trim() !== 'Skype');
                    this.listaTiposContactos.unshift({
                        id: 1,
                        tipoContacto: 'E-mail',
                        usaNewsLetters: true,
                        usarCliente: true,
                        usarRh : true,
                    });

                   if(this.listaDeContactos.length === 0) {
                       this.listaTiposContactos.forEach(t => {
                           const c = this.listaDeContactos.find(a => a.idTipoContacto === t.id);
                           this.contactos.push(this.initFormContacto({
                               ...c,
                               idTipoContacto: t.id,
                               tipoContacto: t.tipoContacto,
                           }));
                       });
                   }
                })
        );
    }



    ngAfterViewInit(): void {

    }

    get contactos() {
        return this.formContacto.get('contactos') as FormArray;
    }

    validarContacto(index: number, chaves: string[]): boolean {
        chaves.forEach((chave) => {
            const control: FormControl = this.contactos['controls'][index].get(chave) as FormControl;
            control?.setErrors(null);
            switch (chave) {
                case 'idTipoContacto' : {
                    if (control.value < 1) {
                        control.setErrors({invalido: true});
                        this.valido = false;
                    }
                    break;
                }
                case 'selectedCountryCode' : {
                    const idTipoContacto: number = this.contactos['controls'][index].get('idTipoContacto').value;
                    if (idTipoContacto > 1 && idTipoContacto < 5) {

                        if (!control.value) {
                            control.setErrors({invalido: true});
                            this.contactos['controls'][index].get('contacto').setErrors({invalido: true});
                            this.contactos['controls'][index].get('contacto').markAsTouched();
                            this.valido = false;
                        }
                    }
                    break;
                }
                case 'contacto' : {

                    const idTipoContacto: number = this.contactos['controls'][index].get('idTipoContacto').value;
                    if (idTipoContacto > 1 && idTipoContacto < 5) {
                        const country: Country[] = this.listaContriesFlag.filter((country: Country) => {
                            return country.dialCode === (
                                control.value as string).replace(/\s/g, '');
                        });

                        if (!(country.length === 0 && this.contactos['controls'][index].get('selectedCountryCode').value && control.value)) {
                            control.setErrors({invalido: true});
                            this.valido = false;
                        }
                    } else if (idTipoContacto === 1) {
                        control.addValidators([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
                        control.updateValueAndValidity();
                        if (control.invalid) {
                            this.valido = false;
                        }
                    } else {
                        control.addValidators([Validators.required]);
                        control.updateValueAndValidity();

                        if (control.invalid) {
                            this.valido = false;
                        }
                    }
                    break;
                }

            }
            control?.markAsTouched();
        });
        return this.valido;
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes && changes['paises'] && changes['paises'].currentValue) {
            this.paises = changes['paises'].currentValue;
        }

        if (this.obterListasContacto) {
            // Emitir o evento ao parent component //
            this.valido = true;

            this.contactos.controls.forEach((control: FormControl, index) => {

                if (this.contactos.controls[index].value.idTipoContacto) {

                    if (!this.contactos.controls[index].value.idTipoContacto
                        && this.contactos.controls[index].value.idTipoContacto > 0
                        && (this.contactos.controls[index].get('contacto').value
                            && (this.contactos.controls[index].get('contacto').value).trim().length < 1)
                    ) {
                        this.contactos.controls[index].get('invalido').setValue(true);
                    }

                    if (this.contactos.controls[index].get('tipoContacto').value === 'E-mail') {
                        if (!this.validateEmail(control.value.contacto)) {
                            this.contactos.controls[index].get('invalido').setValue(true);
                        } else {
                            this.contactos.controls[index].get('invalido').setValue(false);
                        }
                    }

                }

            });

            this.obterLista.emit({
                valido: (this.contactos.value.filter(obj => obj.idTipoContacto && obj.invalido)).length > 0 ? false : true,
                contactos: this.contactos.value.filter(obj => obj.idTipoContacto && obj.contacto !== null).map(obj => obj),
                ContactosRemover: [...this.ContactosRemover]
            });
        }

        if (this.actualizarListasContacto && this.listaDeContactos.length > 0) {
            while(this.contactos.controls.length > 0) {
                this.contactos.removeAt(0);
            }
            this.listaDeContactos.forEach(c => {
                const i = (this.contactos.value as any[]).findIndex(x => x.idTipoContacto === c.idTipoContacto);
               this.contactos.push(this.initFormContacto(c));
                // if (i > -1) {
                //   this.contactos.removeAt(i);
                //   this.contactos.insert(i, this.initFormContacto(c));
                // }
            });

            setTimeout(() => {
                const elementosNativosRef = (this.contactosRef as any)._results as any[];

                (elementosNativosRef)?.forEach(nativoRef => {
                    const id = nativoRef?._id;
                    if (id) {
                        const lista = (id as string).split('-');
                        const index = lista[lista.length - 1];
                      //  const native: HTMLElement = document.getElementById(id);
                      //  const country: Country = (this.contactos['controls'][index].get('selectedCountryCode')).value;

                        // Ver se uso outro prara inicializar
                      //  this.changeCountryCode(id, country, parseInt(index, 10));
                    }
                });
            }, 500);
        }
    }


    initStrSelect() {
        this.strSelect1 = '<div class="mat-select-value ng-tns-c143-30" ng-reflect-ng-switch="false" id="mat-select-value-17"><span class="mat-select-value-text ng-tns-c143-30 ng-star-inserted" ng-reflect-ng-switch="false" style=""><span class="mat-select-min-line ng-tns-c143-30 ng-star-inserted">';
        this.strSelect2 = '</span></div><div class="mat-select-arrow-wrapper ng-tns-c143-30"><div class="mat-select-arrow ng-tns-c143-30"></div></div>';
    }


    initFormContacto(contacto: ClienteContactos | null): FormGroup {
        let res = null;
        let countryCod = null;
        if (contacto?.idTipoContacto > 1 && contacto?.idTipoContacto < 5) {
            res = contacto?.contacto ? this.encontrarCodIso(contacto.contacto) : null;
            countryCod = res?.country ? res.country : null;
        }
        return this.fb.group({
            idContacto: contacto?.idContacto ?? 0,
            idCliente: this.idCliente,
            contacto: contacto?.contacto ?? '',
            caracterValido: false,
            invalido: false,
            valorAux: countryCod || '',
            selectedCountryCode: countryCod || [],
            idTipoContacto: contacto?.idTipoContacto,
            tipoContacto: contacto?.tipoContacto ?? '',
            activo: contacto?.activo,
            default: contacto?.default,
        });
    }


    async aoEscrever(formGroup: FormGroup, idComponent: string, i) {
        // await this.adicionarNovoContactoForm(idComponent, i, 3, 2);
        const control: FormControl = formGroup.get('contacto') as FormControl;
        control.setValidators(null);
        control.updateValueAndValidity();
        control.markAsTouched();
        // this.validarcontacto(control, 'E-mail');
    }


    changeCountryCode(idInPut: string, country: Country, index: number) {
        this.isoCountryCode = null;
        const fg = this.contactos['controls'][index];
        const native: HTMLElement = document
            .getElementById(idInPut) ?
            document.getElementById(idInPut)
                .children[0] as HTMLElement : null;

        let valor: string[] = [];
        let contacto = '';

        if ((fg.get('contacto').value.split(' ') as []).length > 1) {
            valor = fg
                .get('contacto')
                .value.split(' ');
        } else {
            contacto = (fg
                .get('contacto')
                .value as string).replace(this.indicativoActual, '');
        }

        let valorAux = '';
        for (let i = 1; i < valor.length; i++) {

            valorAux += ' ' + valor[i];
        }

        if (native && country) {
            native.innerHTML = this.strSelect1 + country.flag + this.strSelect2;
        }

        let countryCode = '';

        this.indicativoActual = country.dialCode;
        if (valor.length > 1) {
            countryCode = valor.length > 1 ? country.dialCode + valorAux :
                country.dialCode + ' ';
        } else {

            const Tel = this.encontrarCodIso(contacto);
            if (Tel === null || Tel === undefined) {

                countryCode = country.dialCode + contacto;
            } else {
                countryCode = contacto.replace(Tel.country.dialCode, country.dialCode);

            }
        }


        fg.get('contacto').setValue(countryCode);
        fg.get('valorAux').setValue(this.countryCode);
    }


    encontrarCodIso(telefone: string): { telefone: string, country: Country } | null {
        if (telefone && telefone !== '') {
            let auxTel: string = telefone;
            if ((telefone as string)
                .startsWith('00')) {
                auxTel = telefone.replace('00', '+');

            }
            const listaContriesFlagAux: Country[] = this.countryCod.getContryObject();

            listaContriesFlagAux.sort((a, b) => {
                return parseInt(b.dialCode, 10) - parseInt(a.dialCode, 10);
            });

            for (const element of listaContriesFlagAux) {
                const codIso = element.dialCode;
                if (auxTel.startsWith(codIso)) {
                    return {telefone, country: element};
                }
            }
        } else {
            return null;
        }
    }


    onInput(index: number, contacto: any) {
        const valorContacto = contacto.value;
        if (index === 0
            //  && valorContacto.contacto !== ''
            && valorContacto.idTipoContacto > 0) {
            this.contactos.insert(0, this.initFormContacto(null));
        }
    }

    validateEmail(email: string) {
        // Regular expression pattern for basic email validation
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Check if the email matches the pattern
        return pattern.test(email);
    }


}
